import React, { Fragment, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useForm, Controller } from "react-hook-form"
import { selectors as appSelectors } from '../features/app'
import { actionTypes as qaActionTypes, selectors as qaSelectors } from '../features/qa'
import { IAnswer } from '../features/qa/types'
import FieldRadioGroup from '../components/FieldRadioGroup'
import FieldSelect from '../components/FieldSelect'
import { AnalyticElement, AnalyticType, IRadioValue, YesNoNotSure } from '../types.d'
import ErrorSummary from '../components/ErrorSummary'

interface ContactValues {
  handleAnalyticEvent: Function, 
  handleDetailSubmit: Function
}
const Detail: React.FC<ContactValues> = ({ handleAnalyticEvent, handleDetailSubmit }) => {
  type FormData = {
    mods: number,
    planOnReplacing: number, 
    interestedNext: string
  };

  const dispatch = useDispatch();
  const disabled = useSelector(appSelectors.getAppIsLoading);
  const answers: Array<IAnswer> = useSelector(qaSelectors.getQaAnswers);
  const mods: IAnswer = answers.filter((o: IAnswer) => o.key == "mods")[0];
  const planOnReplacing: IAnswer = answers.filter((o: IAnswer) => o.key == "planOnReplacing")[0];
  const interestedNext: string = useSelector(qaSelectors.getQaInterestedNext);
  const [showExtraQuestion, setShowExtraQuestion] = useState(false);
  const { handleSubmit, control, formState: { errors } } = useForm<FormData>();

  const options: Array<IRadioValue> = [
    { label: 'Yes', value: 2},
    { label: 'No', value: 1},
    { label: 'Not Sure', value: -1},
  ];
  const interestedOptions: Array<IRadioValue> = [
    { label: 'New Toyota', value: 'New Toyota'},
    { label: 'Toyota Certified Pre-Owned Cars', value: 'Toyota Certified Pre-Owned Cars'},
    { label: 'Other', value: 'Other'}
  ]
  const handleFieldFocus = (name: string) => {
    handleAnalyticEvent({
      type: 'focus', 
      field: name
    })
  };
  const handleButtonClick = (name: string) => {
    handleAnalyticEvent({
      type: AnalyticType.Click, 
      element: AnalyticElement.Button,
      name
    });
  };
  const onSubmit = (data: FormData) => {
    dispatch({ type: qaActionTypes.SET_QA, payload: {
      interestedNext: data.interestedNext
    } });
    dispatch({ type: qaActionTypes.SET_QA_ANSWERS, payload: data });
    handleDetailSubmit(data);
  }

  return (
    <Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled}>
          <Controller control={control}
            name="planOnReplacing"
            rules={{ required: `This question has not been answered: ${planOnReplacing.Question}` }}  
            render={({ field: { onChange, value, name, ref } }) => {
              const handleFieldChange = (e: any | null) => {
                onChange(e);
                setShowExtraQuestion(e.target.value == YesNoNotSure.Yes);
              };
              return <FieldRadioGroup
                defaultValue={planOnReplacing.Value}
                name={name} 
                inputRef={ref}
                label={planOnReplacing.Question} 
                options={options}
                error={errors.planOnReplacing} 
                onChange={handleFieldChange}
              />
            }} 
          />
          {showExtraQuestion ? <Controller control={control}
            name="interestedNext"
            rules={{ required: `This question has not been answered: What are you interested in next?` }}  
            render={({ field: { onChange, value, name, ref } }) => {
              const handleSelectChange = (selectedOption: any | null) => {
                onChange(selectedOption?.value);
              };
              return <FieldSelect 
                name={name}
                inputRef={ref}
                defaultValue={{label: 'What are you interested in next?', value: interestedNext}}
                options={interestedOptions}
                error={errors.interestedNext}
                onFocus={() => handleFieldFocus('Interested in')}
                onChange={handleSelectChange}
              />
            }} 
          /> : ''}
          {/* <ErrorSummary errors={errors} /> */}
          <div className="i-button-group">
            <button type="submit" className="button-outline" onClick={() => handleButtonClick('Continue')}>Continue</button>
          </div>
        </fieldset>
      </form>
    </Fragment>
  )
}

export default Detail;